import { Component, OnInit,Input,ViewChild,HostListener, ElementRef } from '@angular/core';
import {BlogService} from "../../service/blog.service";
import {commonService} from "../../service/common.service";
import {Globals } from '../../globals';
import { HttpDownloadProgressEvent, HttpErrorResponse } from '@angular/common/http';
import {NgbModal, ModalDismissReasons,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import { NgForm } from '@angular/forms';
import {ParamMap, Router, ActivatedRoute,Params } from '@angular/router';
import { Http, ResponseContentType } from '@angular/http';
import {FileSelectDirective,FileUploader, FileItem, ParsedResponseHeaders } from 'ng2-file-upload';


@Component({
  selector: 'app-bloglist',
  templateUrl: './bloglist.component.html',
  styleUrls: ['./bloglist.component.css']
})
export class BloglistComponent implements OnInit {
  msg="";
  bloglist:any;
  newBlog=false;
  blogId=0;
  commentbox=[];
  userData:any;
  commentEditbox=[];
  currentUploadComment:any={};
  currentCommentMediaIds:any=[];
  replybox:any;
  @Input() option;
  blogOption:any;
  msgpopup="";
  blogFields:any;
  ckeConfig={}
  modalReference:NgbModalRef;
  msgclass="danger";
  blogsavemessage=false;
  isblogLoad=false;
  isRemaningBlog=true;
  blogEditFields={};
  currentblog={};
  editIndex:any;
  //filterform:any;
  autoload:any;
  blogdetails:any;
  searchtxt:any;


  attactmentlist:any=[];
  selectedFile=null;
  attachment:any=[];
  attachmentdetail:any=[];
  fileExtExists=false;
  attachmentUrl =this.global.siteUrl+'file/upload?folder='+this.global.postAttachmentFolder+'&mediaFor=userPost';
  uploader:FileUploader=new FileUploader({url:this.attachmentUrl,authToken:localStorage.getItem('_to')});
  fileExt: string = "JPG, JPEG, PNG,doc,docx,txt,ppt,pptx";
  uploaders:FileUploader=new FileUploader({url:this.attachmentUrl,authToken:localStorage.getItem('_to')});;

  audiosContainer:any;
  mediaConstraints = { audio: true }
  recorderType:any;
  thisObj:any; 
  audio:any;
  mediaRecorderObj:any;
  mediaRecorder:any;
  MoreButton=true;
  isBlogLoad=true;
  isBlogclickbutton=false;
  
  constructor(private http:Http,private modalService: NgbModal,private commonService:commonService,private blogService:BlogService,private global: Globals,private router: Router,private route: ActivatedRoute) {
    this.bloglist=[];
  
    this.uploader.onErrorItem = (item, response, status, headers) => this.onErrorItem(item, response, status, headers);
    this.uploader.onSuccessItem = (item, response, status, headers) => this.onSuccessItem(item, response, status, headers);

    this.uploaders.onErrorItem = (item, response, status, headers) => this.onErrorItemComment(item, response, status, headers);
    this.uploaders.onSuccessItem = (item, response, status, headers) => this.onSuccessItemComment(item, response, status, headers);
    this.blogFields={};
        this.ckeConfig = {
      height: 100,
      width:'100%',
      language: "en",
      
   //   extraPlugins: 'mathjax',
      
      mathJaxLib: 'https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.0/MathJax.js?config=TeX-AMS_HTML',
     // allowedContent: true,
     // extraPlugins: "divarea",
      toolbar: [
         // { name: "editing", items: ["Scayt", "Find", "Replace", "SelectAll"] },
         // { name: "clipboard", items: ["Cut", "Copy", "Paste", "PasteText", "PasteFromWord", "-", "Undo", "Redo"] },
          { name: "links", items: ["Link", "Unlink", "Anchor"] },
        //  { name: "tools", items: ["Maximize", "ShowBlocks", "Preview", "Print", "Templates"] },
         // { name: "document", items: ["Source"] },
          { name: "insert", items: ["Image", "Table", "HorizontalRule", "SpecialChar", "Iframe", "imageExplorer"] },
         //{ name: "insert", items: ["Image", "Table",  "imageExplorer","Iframe"] },
        // For New Line  "/",
          { name: "basicstyles", items: ["Bold", "Italic", "Underline", "Strike", "Subscript", "Superscript", "-", "RemoveFormat"] },
          { name: "paragraph", items: ["NumberedList", "BulletedList", "-", "Outdent", "Indent", "Blockquote"] },
         // { name: "justify", items: ["JustifyLeft", "JustifyCenter", "JustifyRight", "JustifyBlock"] },
        //  { name: "styles", items: ["Styles", "Format", "FontSize", "-", "TextColor", "BGColor"] }
      ],
      filebrowserUploadUrl : this.global.siteUrl+'ckeditor/upload'
  };


    

    this.commonService.profile.subscribe((data:any)=>{
      // console.log('after Load call sub');
       if(data){
       this.userData=data; 
       }else{
         this.userData={};
       } 
 
     });

    
     this.replybox={};

   }

  /*   @HostListener('window:scroll', ['$event'])
   checkScroll() {
   var scrollPosition = $(window).scrollTop() + $(window).height();
      //var pageheight =  $(document).height()-$('#footer-section').outerHeight();
      var pageheight =  $(document).height()-100;
      if(scrollPosition >= pageheight && this.isRemaningBlog==true && this.blogId==0 && this.isblogLoad!=true) {
        this.isblogLoad=true;        
       // this.loadmoreBlog();
      }

 }*/

  ngOnInit() {
    
   
   
     if(this.option){
      this.blogOption=this.option;
      }
      if( this.blogOption && this.blogOption['blogId'] > 0){
        this.blogId=this.blogOption['blogId'];


      }

    let filter={};
    filter['userId']=(this.userData.id)?this.userData.id:0;
    if(this.option.blogId > 0){
      this.MoreButton=false;
      filter['blogId']=this.option.blogId;
      filter['limit']=1;
      filter['offset']=0;

      filter['newBlog']=true;
    }
    this.getBlogList(filter);
  }


  saveblog(blogForm:NgForm){

    this.msgpopup="";
    let localmodalReference=this.modalReference;
    let forumsObj=blogForm.value; 
    //forumsObj.postTitle[forumsObj.postTitle.length -1];
    
    if(this.userData.isBlocked == 1){
      this.msgclass="danger";
      this.msgpopup="You have no permission to post question, Please contact to MadeEasy";
      return false;
    }

    if(blogForm.valid==true){
      let blogObj=blogForm.value; 
      let obj={};
      this.isBlogclickbutton=true;
      obj['userId']=this.userData.id;
      obj['title']=blogObj.title;
      obj['content']=blogObj.content;
      obj['status']=1;
      obj['approve']=0;
      this.blogService.saveBlog(obj).subscribe((data:any)=>{
        this.isBlogclickbutton=false;
        
        if(data.error==0){
          this.blogFields={};      
          this.msgclass="success";
          this.msgpopup="Blog has been saved successfully. This Blog is pending approval, It will start to appear in the Blog section once it gets approved by the Moderator.";
          this.blogsavemessage=true;
          this.blogsavemessage=false;
  
          blogForm.resetForm();
          
        }else{
          this.msgclass="danger";
          this.msgpopup=data.message;

        }
       
      },(error:HttpErrorResponse)=>{
        this.msgclass="danger";
        this.msgpopup="internal server error!";
      })
    }else{
      this.msgclass="danger";
      this.msgpopup="Please fill all required fields!";
      }

  }

  open(content) {
    if(Object.keys(this.userData).length == 0){ 
      this.needLogin();
      return false;
    } 
    this.blogsavemessage=false;
    this.msgpopup="";
    this.modalReference =  this.modalService.open(content,{ size: 'lg' });          
  }
  getBlogList(obj){
    obj['status']=1;
    obj['approve']=1;
    obj['limit']=10;
    obj['offset']=this.bloglist.length?this.bloglist.length:0
    obj['launchDateCheck']=true;
    
      this.blogService.getBlogList(obj).subscribe((data:any)=>{
        this.isBlogLoad=false;
          if(data.error==0){
          
            if(data.result.length > 0){
              for(let i=0; i < data.result.length; i++){
               this.customContent(data.result[i]);
              }
            }
          
            if(obj.newBlog==true){
             this.bloglist=data.result;
            
            }else{
             Array.prototype.push.apply(this.bloglist,data.result); 
            }

          }

      },(error:HttpErrorResponse)=>{
        this.msg="internal server error!";
      })


  } 

  loadmoreBlog(){
    this.getBlogList({limit:10,newBlog:false});
  }

  blogdetailredirect(id){
let url =encodeURI(btoa(id));
this.router.navigate(['blog/'+url]);
  }


  bookmark(blogObj,type){
    var obj={};
    obj['blogId']=blogObj.id;
    obj['userId']=this.userData.id;
    obj['type']=type;
    this.blogService.bookmark(obj).subscribe((data:any)=>{
      if(data.error==0){
        if(type=='bookmark'){
          blogObj.mybookmark=1;
        }else{
          blogObj.mybookmark=0;
        }
        blogObj.showOption=false;
    
      }
    
    },(error:HttpErrorResponse)=>{
      this.msg="internal server error!";
    })
    
    }

    deleteblog(blogObj,index){
      var r=confirm("Do you want to delete ?");
      if(r==true){
        let obj={};
        obj['id']=blogObj.id;
    this.blogService.deleteBlog(obj).subscribe((data:any)=>{  
      this.bloglist.splice(index,1);
    },(error:HttpErrorResponse)=>{
      this.msg="internal server error!";
  
    })
       
  
      }
    }

    editblogBox(blogObj,index,editcontent){
      //console.log(postObj);
      this.currentblog=blogObj;
      this.editIndex=index;
      this.blogEditFields['id']=blogObj.id;
      this.blogEditFields['title']=blogObj.title;
      this.blogEditFields['content']=blogObj.content;     
      this.blogEditFields['isfuture']=false;
      this.blogEditFields['launchDate']=blogObj.launchDate;
      this.blogEditFields['launchtime']={}
      
      //console.log(this.blogEditFields);
      this.open(editcontent);
      blogObj.showOption=false;         
  
    }
  
    updateblog(blog){
      let content=this.blogEditFields['content'];
      let title=this.blogEditFields['title'];
    let obj={};
    obj['id']=this.currentblog['id'];
    obj['content']=content;
    obj['title']=title;  

    if(this.userData.isBlocked == 1){
      this.msgclass="danger";
      this.msgpopup="You have no permission to post question, Please contact to MadeEasy";
      return false;
    }

   
    if(blog.valid==true){
      this.isBlogclickbutton=true;
      this.blogService.updateBlog(obj).subscribe((data:any)=>{
        this.isBlogclickbutton=false;
        if(data.error==0){
          this.bloglist[this.editIndex]['content']=content;
          this.bloglist[this.editIndex]['title']=title;
       
          //this.customContent(blog);
          this.bloglist[this.editIndex]['editmode']=false;      
          this.modalReference.close();
          this.blogEditFields={}
        }         
  
      },(error:HttpErrorResponse)=>{
        this.msg="internal server error!";
      })
    }else{
      this.msgclass="danger";
      this.msgpopup="Please fill all required fields!";
      }
  
  }

  blogLike(blogObj,react){ 
    if(Object.keys(this.userData).length == 0){ 
      this.needLogin();
      return false;
    }      
    var obj={};
    obj['userId']=this.userData.id;
    obj['blogId']=blogObj.id;
    obj['react']=react;            
        this.blogService.saveBlogLike(obj).subscribe((data:any)=>{
          if(data.error==0){
            this.postLikefunc(blogObj,react,data.message);             
            }         
        },(error : HttpErrorResponse)=>{              
            this.msg="internal server error!";
        })   
    

  }


  postLikefunc(blogObj,react,action){

    if(!blogObj.blogLikeCount){
      blogObj.blogLikeCount=0;
    }
    if(!blogObj.blogunLikeCount){
      blogObj.blogunLikeCount=0;
    }

     // react=0 unlike
    if(react==0 && action=="added"){ 
      blogObj.mylike=0;
      blogObj.blogunLikeCount +=1;
      blogObj.mylikeAction='Unlike';
        } else if(react==0 && action=="updated"){
          blogObj.mylike=0;
          blogObj.blogLikeCount -=1;
          blogObj.blogunLikeCount +=1;
          blogObj.mylikeAction='Unlike';
        }else if(react==1 && action=="added"){
          blogObj.mylike=1;
          blogObj.blogLikeCount +=1;
          blogObj.mylikeAction='Like';
        }else if(react==1 && action=="updated"){
          blogObj.mylike=1;
          blogObj.blogLikeCount +=1;
          blogObj.blogunLikeCount -=1;
          blogObj.mylikeAction='Like';
        } else if(react==0 && (action=="removed")){
         // console.log('111111111');
         blogObj.mylike=0;
         blogObj.blogunLikeCount -=1;
         blogObj.mylikeAction='';
        }else if(react==1 && (action=="removed")){
        //  console.log('22222222');
        blogObj.mylike=0;
        blogObj.blogLikeCount -=1;
        blogObj.mylikeAction='';
        }

      //  console.log(postObj);

  }


  customContent(ans){
    //console.log('ans');
   // console.log(ans);
    let string="";
    ans.shortAns="";
    ans.shortImage="";
   let html =ans.content
   //console.log(this.postId);

    if(this.blogId  > 0 ||  ans.isfullcontent==true){
     string=html;
    }else{
     let chacterlength=0;
     let obj= html.split('<p>');
     var incre=0;
       for(var i in obj){
         incre++;  
         if(obj[i]){

           var StrippedString = obj[i].replace(/(<([^>]+)>)/ig,"");
           chacterlength +=StrippedString.length;
          // console.log(StrippedString);
           //string +='<p>'+obj[i];
           string +=StrippedString;
           //break;
         }
         if(chacterlength > 350){
          ans.isfullcontent=false;
           break;
         }                
       }  
       ans.shortAns=string;
//console.log(incre +'----'+obj.length);
       if(incre < (obj.length-1) ){
        // console.log(html);
         if(html.indexOf('<img') !==false){
         var m,
         urls = [], 
         str = html,
         rex = /<img[^>]+src="?([^"\s]+)"?\s*\/>/g;
         while ( m = rex.exec( str ) ) {
             urls.push( m[1] );
         }

        // console.log( urls );
           if(urls.length > 0){
             ans.shortImage=urls[0];
             //string ='<div class="row grid-divider"><div class="col-sm-8 short-content-ans">'+string+'</div>'+'<div class="col-sm-4 short-image-ans"><img class="img-thumbnail" src="'+urls[0]+'" /></div></div>'; 
           }
         }
       //  let imageobj= html.split('<img');
         //console.log(imageobj);
        // ans.isfullcontent=false;
       }else{
         ans.shortAns=string;
         ans.isfullcontent=true;
       }

    }
    //string=string+'<a class="more-content">more</a>';

   //return string;
  }

  getImagePath(path,anonymously){
    if(!path || anonymously==1){
      path='avatar.png';
    }
  let res=this.global.profileUrl+path;
  return res;

  }
  needLogin(){
    this.commonService.setLoginBox(true);        
  }
  datediff(date){
    return this.commonService.datediff(date);
   }

   commentDetailBox(blog){
     //console.log(blog);
      if(!blog.commentDetailBox || blog.commentDetailBox==false){
        blog.commentDetailBox=true;
      }else{
        blog.commentDetailBox=false;
      }

      this.showAnscomment(blog);

   }
  /**********Comment **********/
  showCommentBox(blogObj){
    if(Object.keys(this.userData).length == 0){ 
      this.needLogin();
      return false;
    } 
    blogObj.showAttachment=false;
    if(blogObj.showCommentBox){
      blogObj.showCommentBox=false;
    }else{
      blogObj.showCommentBox=true;
      
      if(blogObj.commentCount > blogObj.commentCount && blogObj.commentCount < 5){
        blogObj.isCommentLoad=true;
        var obj={};
        obj['userId']=this.userData.id;
        obj['ansId']=blogObj.id;
        obj['limit']=5;
        obj['offset']=blogObj.commentList.length;
      
        this.blogService.getComments(obj).subscribe((data:any)=>{
         
          if(data.error==0){
            if(data.result){
              for(let i in data.result){  
                this.commentEditbox[data.result[i].id]=data.result[i].comment;
              }
            }
            
            Array.prototype.push.apply(blogObj.commentList,data.result); 
            //postObj.postComments.concat(data.result);
           // console.log(postObj.postComments);
          }
          blogObj.isCommentLoad=false;



        },(error : HttpErrorResponse)=>{ 
          blogObj.isCommentLoad=false;     
          this.msg="internal server error!";
        })


      }
    }
  }


  savereply(commentobj,commentValue){
    commentobj.isclickbutton=true;   
    let objthis=this;
    if(commentValue){
          let commentInsertObj={}
          commentInsertObj['comment']=commentValue;
          commentInsertObj['blogId']=commentobj.postId;
          commentInsertObj['userId']=this.userData.id;
          commentInsertObj['pcomment']=commentobj.id;
          commentInsertObj['mediaids']=[];
          if(this.currentCommentMediaIds){
            for(let i in this.currentCommentMediaIds){
              commentInsertObj['mediaids'].push(this.currentCommentMediaIds[i].id);

            }
          }   

          this.blogService.saveComment(commentInsertObj).subscribe((data:any)=>{
            commentobj.isclickbutton=false;  
            commentobj.isEditor=false; 
            if(data.error==0){
              let commentData=data.result;
             
              commentData.user={firstName:this.userData.firstName,lastName:this.userData.lastName,photo:this.userData.photo};
              commentData.likeCount=0;
              if(!commentobj.commentList){
                commentobj.commentList=[];
              }
              commentData.blogcommentAttachments=this.currentCommentMediaIds;
             
             // if(commentobj.commentList.length<5){
                commentobj.commentList.unshift(commentData);
             // }
              commentobj.commentCount +=1;
              objthis.replybox[commentobj.id]="";
              commentobj.commentMedia=[];
            }
            this.currentCommentMediaIds=[];


          },(error : HttpErrorResponse)=>{  
            
              this.msg="internal server error!";
          })

    }       

  }

  saveComment(blogObj,commentValue){

    let objthis=this;
    
    if(commentValue || this.currentCommentMediaIds.length>0){
      blogObj.isclickbutton=true;
          let commentObj={}
          commentObj['comment']=commentValue;
          commentObj['blogId']=blogObj.id;
          commentObj['userId']=this.userData.id;
          commentObj['mediaids']=[];
          if(this.currentCommentMediaIds){
            for(let i in this.currentCommentMediaIds){
              commentObj['mediaids'].push(this.currentCommentMediaIds[i].id);

            }
          }     
          
         
          this.blogService.saveComment(commentObj).subscribe((data:any)=>{
            blogObj.isclickbutton=false;
            blogObj.showCommentBox=false;
            
            if(data.error==0){
              let commentData=data.result;                 
              commentData.user={firstName:this.userData.firstName,lastName:this.userData.lastName,photo:this.userData.photo};
              commentData.likeCount=0;
              
              commentData.blogcommentAttachments=this.currentCommentMediaIds;
              if(!blogObj.commentList){
                blogObj.commentList=[];
              }
              
              blogObj.commentList.unshift(commentData);
               
            
              blogObj.commentCount +=1;
           

              blogObj.commentMedia=[];
              this.commentbox[blogObj.id]="";
              blogObj.showAnscomment=false;
              this.showAnscomment(blogObj);
            }
            this.currentCommentMediaIds=[];


          },(error : HttpErrorResponse)=>{  
              
              this.msg="internal server error!";
          })

    }        
  
  }

  loadComment(postObj,forcall,divobject){
    if(!postObj.commentList){
      postObj.commentList=[];

    }
    if(postObj.commentCount > postObj.commentList.length ){
      postObj.isCommentLoad=true;

      //console.log(forcall);
    var obj={};
     if(this.userData)
     obj['userId']=this.userData.id;
    
     obj['limit']=5;
     obj['offset']=postObj.commentList.length;
     if(forcall=='Comment'){
      obj['postId']=postObj.id;
     }else if(forcall=='reply'){
      obj['postId']=postObj.postId;
      obj['pcomment']=postObj.id;
     }

     obj['ordertype']='DESC';
     obj['orderby']='id';

     //console.log(obj);
     //console.log(postObj);

    
      this.blogService.getComments(obj).subscribe((data:any)=>{
       
        if(data.error==0){
          if(data.result){
            for(let i in data.result){

              this.commentEditbox[data.result[i].id]=data.result[i].comment;
            }
          }
         
          Array.prototype.push.apply(postObj.commentList,data.result); 
          
       
        }
        postObj.isCommentLoad=false;



      },(error : HttpErrorResponse)=>{ 
        postObj.isCommentLoad=false;     
        this.msg="internal server error!";
      })


    }
  }
  commentLike(commentData){

    if(Object.keys(this.userData).length == 0){ 
      this.needLogin();  
      return;
    }
    var obj={};
    obj['userId']=this.userData.id;
    obj['commentId']=commentData.id;
    obj['react']=1;  

      if(commentData.mylike){            
        this.blogService.deleteCommentLike(obj).subscribe((data:any)=>{
          if(data.error==0){
          commentData.mylike=0;
          commentData.likeCount -=1;
          }
        },(error : HttpErrorResponse)=>{              
            this.msg="internal server error!";
        })              

      }else{            

        this.blogService.saveCommentLike(obj).subscribe((data:any)=>{
          if(data.error==0){
          commentData.mylike=1;
          commentData.likeCount +=1;
          }
        },(error : HttpErrorResponse)=>{              
            this.msg="internal server error!";
        })            
      }

  }

  showAnscomment(blogObj){

    if(blogObj.showAnscomment==true){
      blogObj.showAnscomment=false;          
      return false;
    }   

   if(!blogObj.commentList || blogObj.commentList.length==0){
     this.loadComment(blogObj,'Comment','');   
   }
   blogObj.showAnscomment=true;  
  

  }


  replyTextboxShow(commentdata){
        
    if(commentdata.isShow){
      commentdata.isShow=false;

    }else{

      commentdata.isShow=true;
      
      if(!commentdata.commentList){
         commentdata.commentList=[];
      }
      if(commentdata.commentCount > commentdata.commentList.length && commentdata.commentList.length < 5){
       
        commentdata.isCommentLoad=true;
      var obj={};
       obj['userId']=this.userData.id;
       obj['blogId']=commentdata.postId;
       obj['pcomment']=commentdata.id;
       obj['limit']=5;
       obj['offset']=commentdata.commentList.length;
       obj['ordertype']='DESC';
       obj['orderby']='id';
     // console.log(obj);
        this.blogService.getComments(obj).subscribe((data:any)=>{
         
          if(data.error==0){
            if(data.result){
              for(let i in data.result){

                this.commentEditbox[data.result[i].id]=data.result[i].comment;
              }
            }
            Array.prototype.push.apply(commentdata.commentList,data.result); 
            //postObj.postComments.concat(data.result);
            console.log(commentdata.commentList);
          }
          commentdata.isCommentLoad=false;



        },(error : HttpErrorResponse)=>{ 
          commentdata.isCommentLoad=false;     
          this.msg="internal server error!";
        })
      }
    }

  }
  toggleoption(blogObj){      
   
    if(blogObj.showOption){
      blogObj.showOption=false;
    }else{
      blogObj.showOption=true;
    }
  }

  enableEditor(Obj){
    if(Object.keys(this.userData).length == 0){ 
      this.needLogin();
      return false;
    } 
    Obj.isEditor=true;

  }

  
  ngAfterViewInit() {
    this.uploader.onAfterAddingFile = (item => {
       item.withCredentials = false;
    });

    this.uploaders.onAfterAddingFile = (item => {
      item.withCredentials = false;
   });
    /*

      this.uploader.onCompleteAll=function (){
        console.log(this.uploader);
        console.log("Complete Upload");
      }*/
      if(this.blogId > 0){
        //this.setPageCount();
      }
      //this.el.nativeElement.querySelector('.more-content').addEventListener('click', this.showfullContent.bind(this));
      
   }





/*============================================= For Image Upload Code ===============================*/
  /********** For upload Attachement *****/
  onFileChanged(event) {
    this.uploader.uploadAll();
   }
 
   uploadComment(commnetobj,content){
     this.currentUploadComment = commnetobj;    
     this.open(content);
 
   }
 
   onFileChangedComment(event) {
     this.uploaders.uploadAll();
 
     //uploader:FileUploader=new FileUploader({url:this.attachmentUrl,authToken:sessionStorage.getItem('_to')});
    // this[name].uploadAll();
    }
 
   
 
 
   downloadAttachment(attachmentObj){
     if(Object.keys(this.userData).length == 0){ 
       this.needLogin();
       return false;
     } 
    
 
     var url=this.global.postAttachmentUrl+attachmentObj.uploadname;
     return this.http.get(url,{
       responseType: ResponseContentType.Blob,
     })
     .map(res => {
       return {
         filename: attachmentObj.uploadname,
         data: res.blob()
       };
     }).subscribe(res => {
         var url = window.URL.createObjectURL(res.data);
         var a = document.createElement('a');
         document.body.appendChild(a);
         a.setAttribute('style', 'display: none');
         a.href = url;
         a.download = res.filename;
         a.click();
         window.URL.revokeObjectURL(url);
         a.remove(); // remove the element
       }, error => {
         //console.log('download error:', JSON.stringify(error));
              if(error.status="404"){
                     alert('Something went wrong. Please try to latter.');
              }
       }, () => {
        // console.log('Completed file download.')
       });
 
 
    
 
   }
 
 
   private isValidFileExtension(files){
     // Make array of file extensions
      var extensions = (this.fileExt.split(','))
                    .map(function (x) { return x.toLocaleUpperCase().trim() });
                    console.log(extensions+'test');
   //  // Get file extension
         var ext = files[0].name.toUpperCase().split('.').pop() || files[0].name;
        // console.log(ext+'test321');
         // Check the extension exists
         var exists = extensions.includes(ext);
         if(!exists){
             this.fileExtExists=true;
         }
         else{
           this.fileExtExists=false;
         }
       
     
   }
 
 
   onSuccessItem(item: FileItem, response: string, status: number, headers: ParsedResponseHeaders): any {
  // console.log("Success");
     //console.log(item); 
     let data = JSON.parse(response); //success server response
 
       if(data.error==0){
        // console.log("set Ids");
         //console.log(data.result.id);
 
         this.attachment.push(data.result.id);
         this.attachmentdetail.push(data.result);
        // console.log(this.attachment);
       }else{
 
         this.msgpopup="There is some technical problem. Please try again";
         this.uploader.clearQueue();
       }
      
   }
 
   onErrorItem(item: FileItem, response: string, status: number, headers: ParsedResponseHeaders): any {
       let error = JSON.parse(response); //error server response
       this.msgpopup="There is some technical problem. Please try again";
       this.uploader.clearQueue();
   }
 
   onSuccessItemComment(item: FileItem, response: string, status: number, headers: ParsedResponseHeaders): any {
    // console.log("Success");
    //   console.log(item); 
       let data = JSON.parse(response); //success server response
   
         if(data.error==0){
          // console.log("set Ids");
          // console.log(data.result.id);  
           this.currentCommentMediaIds.push(data.result.mediaDetail);       
         }else{
 
           this.msgpopup="There is some technical problem. Please try again";
           this.uploaders.clearQueue();
         }
        
     }
   
     onErrorItemComment(item: FileItem, response: string, status: number, headers: ParsedResponseHeaders): any {
         let error = JSON.parse(response); //error server response
         this.msgpopup="There is some technical problem. Please try again";
         this.uploaders.clearQueue();
     }
 
     cancelCommentUpload(){
       this.currentCommentMediaIds=[];
       this.currentUploadComment={};
       let localmodalReference=this.modalReference;
       localmodalReference.close();
       this.uploaders.queue=[];
 
     }
 
 
     SaveCommentUpload(){      
       this.currentUploadComment.commentMedia=this.currentCommentMediaIds;
       this.currentUploadComment={};    
       let localmodalReference=this.modalReference;
       localmodalReference.close();
       this.uploaders.queue=[];
     }

     filteruser(search){

      // console.log(search);
      var searchtxt  = search.trim();
 
      if(searchtxt!=""){ 
            this.blogService.filterblog({"search":searchtxt}).subscribe((data:any)=>{
            if(data.error==0){ 
        
             this.blogdetails = data.results.rows;
     
            }else{
              if(data.message=="Failed to authenticate token."){
                this.router.navigate(['/']);
              }else{
              }
              }
          },
              (error : HttpErrorResponse)=>{
              //  this.isError = true;
                //this.msg="internal server error!";
              });
      }else{
        this.blogdetails=[];
      }
     }
     
     putdata(objData,event){
     
     this.searchtxt =event.target.innerHTML; 

       this.blogdetails=[];
       var filter={};
       filter['blogId']=objData.id;
       filter['limit']=1;
       filter['offset']=0;
       this.blogService.getBlogList(filter).subscribe((data : any)=>{
         if(data.error==0){ 
          if(data.result.length > 0){
            for(let i=0; i < data.result.length; i++){
              this.customContent(data.result[i]);
            }
          }
          this.bloglist =data.result;
        
         }else{
           if(data.message=="Failed to authenticate token."){
             this.router.navigate(['/']);
           }else{
           this.msg = data.message;
          // this.isError = true;
           //this.isSuccess = false;
           }
         }
     },
         (error : HttpErrorResponse)=>{
          // this.isError = true;
           this.msg="internal server error!";
         });

     }

     checkFileextension(fileName){
      return this.commonService.checkFileextension(fileName);
     } 

     EditComment(commentObj){
      //commentObj.comment=;
      
    let obj = {};
    obj['id']=commentObj.id;
    obj['comment']=this.commentEditbox[commentObj.id];
    commentObj.isclickbutton=true;
   
      this.blogService.editComment(obj).subscribe((data:any)=>{
        commentObj.isclickbutton=false;
        commentObj.editMode=false;
        commentObj.comment=this.commentEditbox[commentObj.id];
      })
      

    }

    openEditComment(commentObj){  
      commentObj.editMode=true; 
      commentObj.showOption=false;          
    }

    cancelEditComment(commentObj){
      commentObj.editMode=false;
    }

    deleteComment(commentObj,parentObj,index){
      var obj={};
      obj['id']=commentObj.id;
      this.blogService.deleteComment(obj).subscribe((data:any)=>{
        if(data.error==0){
          try{
            parentObj.commentList.splice(index, 1);
              parentObj.commentCount -=1; // for reply && comment

          }catch(e){
            //console.log(e);
          }            
        }
      },(error:HttpErrorResponse)=>{
        this.msg="internal server error!";
      })

    }

    removeAttachment(obj,index,postAnswerContent){
      obj[index].postAnswer=false;
      if(confirm("Do you want to delete ?")){
         if(postAnswerContent.trim()=="" && obj.length==1){
          obj[index].postAnswer=true;
         }
  
     this.blogService.removeCommentAttachment(obj[index]).subscribe((data:any)=>{
      if(data.error==0){
        try{
          obj.splice(index, 1);
        }catch(e){
         // console.log(e);
        }            
      }
    },(error:HttpErrorResponse)=>{
      this.msg="internal server error!";
    })
      }
    }

}



// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/home/bloglist/bloglist.component.ts